// Helpers para o player do YouTube (IFrame Player API).

// Extrai o ID do vídeo de qualquer formato de URL do YouTube.
export function extrairVideoId(url?: string): string | null {
  if (!url) return null;
  const padroes = [
    /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/shorts\/)([\w-]{11})/,
    /[?&]v=([\w-]{11})/,
  ];
  for (const p of padroes) {
    const m = url.match(p);
    if (m && m[1]) return m[1];
  }
  // caso a URL já seja só o id
  if (/^[\w-]{11}$/.test(url.trim())) return url.trim();
  return null;
}

// Carrega a IFrame Player API uma única vez e resolve quando estiver pronta.
export function carregarYoutubeApi(): Promise<any> {
  return new Promise((resolve) => {
    const w = window as any;
    if (w.YT && w.YT.Player) {
      resolve(w.YT);
      return;
    }
    const anterior = w.onYouTubeIframeAPIReady;
    w.onYouTubeIframeAPIReady = () => {
      if (typeof anterior === "function") anterior();
      resolve(w.YT);
    };
    if (!document.getElementById("yt-iframe-api")) {
      const tag = document.createElement("script");
      tag.id = "yt-iframe-api";
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }
  });
}
